<!-- Magazine frontpage -->
<template>
    <div class="magazine-frontpage">
        <template v-if="page">
            <WpContent :html="page.content" />
        </template>
        <LoadingIndicator v-else class="magazine-frontpage__loading" />
    </div>
</template>

<router>
{
    meta: {
        hideGettingStartedProgressBar: true
    }
}
</router>

<script>
import magazineHelpersMixin from '~/mixins/magazineHelpersMixin';
import CmsService from '~/services/CmsService';
import LoadingIndicator from '~/components/LoadingIndicator.vue';
import WpContent from '~/components/WpContent.vue';

const NOT_FOUND_ERROR = '404 page not found';

export default {
    name: 'MagazineFrontpage',
    components: {
        LoadingIndicator,
        WpContent,
    },
    mixins: [magazineHelpersMixin],
    layout: 'magazine',
    async asyncData(context) {
        const cmsService = new CmsService(context.app);

        try {
            return { page: await cmsService.getFrontpage() };
        } catch (error) {
            if (error?.message === NOT_FOUND_ERROR) {
                context.app.$sentry.captureException(error);
            }
        }
    },
    data() {
        return {
            page: null,
        };
    },
    head() {
        if (!this.page?.seoMeta) {
            return {};
        }

        const homepageMapping = { ...this.baseMetaMapping, ...this.ogImageMapping };
        const meta = this.generateMeta(this.page.seoMeta, homepageMapping);

        return {
            title: this.page.seoMeta.og_title || this.$t('magazine.heading'),
            meta,
        };
    },
    nuxtI18n: {
        // Sync with getLocalizedPathForRoute in LanguageSwitcherMainContent
        paths: {
            se: '/magasin',
            'fi-sv': '/magasin',
            en: '/magazine',
            de: '/magazin',
            at: '/magazin',
            fi: '/lehti',
            no: '/magasin',
            dk: '/magasin',
            ch: '/magazin',
            fr: '/magazine',
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.magazine-frontpage {
    &__loading {
        height: calc(100dvh - $main-header-md-height);
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
